import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { HapiElementsLoader } from 'modules/ats/components/HapiElementsLoader'
import { VonqImportedContracts } from 'modules/ats/components/VonqImportedContracts'
import { useAtsContext } from 'modules/ats/lib/atsContext'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CalendarSync } from './CalendarSync'
import { OtherAddons } from './OtherAddons'
import { PromoteJobsAddons } from './PromoteJobsAddons'

const IntegrationsPage = () => {
  const { canManageAtsSettings } = useAtsContext()
  const { loading } = useAsyncData(
    async () => (canManageAtsSettings ? subscriptionAddons.fetch() : false),
    []
  )
  const { featureAvailability } = useFeatureAvailability(Features.ats_vonq)
  const hasJobBoardsEnabled = featureAvailability.available

  return (
    <ResponsivePage.Body
      authorized={canManageAtsSettings}
      loading={loading}
      error={null}
      showHeader={false}
    >
      <Box gap="s48">
        <Box gap="s32" paddingY="s48" paddingX="s64">
          {hasJobBoardsEnabled && (
            <HapiElementsLoader>
              <VonqImportedContracts />
            </HapiElementsLoader>
          )}
          <PromoteJobsAddons />
          <CalendarSync />
          <OtherAddons />
        </Box>
      </Box>
    </ResponsivePage.Body>
  )
}

export default IntegrationsPage
